export const CHART_TIMES = {
  1: '1 _[day]_',
  2: '2 _[days]_',
  7: '1 _[week]_',
  14: '2 _[weeks]_',
  30: '1 _[month]_',
  60: '2 _[months]_',
  90: '3 _[months]_',
  180: '6 _[months]_',
};
